import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Account } from "src/app/authentication/models/account.model";
import { AccountPermission } from "../models/account-permission.model";
import { User } from "../models/user.model";
import { UserPermissionInputModel } from "../models/input-models/user-permission-input.model";
import { System } from "src/app/all-charts/models/system.model";
import { Configurations } from "../models/configuration.model";
import { configurationInputModel } from "../models/input-models/configuration-input.model";
import { LicenseProduct } from "src/app/all-charts/models/licenseProduct.model";

@Injectable()
export class PermissionsService {
  companyApiUrl: string;
  summariesApiUrl: string;
  projectsApiUrl: string;
  apiUrl: string;
  portalApiUrl: string;

  constructor(private http: HttpClient) {
    this.companyApiUrl = environment.apiUris.companyApiUri;
    this.summariesApiUrl = environment.apiUris.chartsApiUri;
    this.projectsApiUrl = environment.apiUris.projectsApiUri;
    this.apiUrl = environment.apiUris.identitiesApiUri;
  }

  getProductsLicenseOwnership(accountId: string): Observable<boolean>{
    return this.http.get<boolean>(`${this.summariesApiUrl}/Accounts/${accountId}/User/ProductOwnership`);
  }

  getSystems(accountId: string, productType: number): Observable<System[]> {
     return this.http.get<System[]>(`${this.companyApiUrl}/Accounts/${accountId}/ProductTypes/${productType}/Systems`);
  }

  getLicenseProducts(accountId: string): Observable<LicenseProduct[]> {
     return this.http.get<LicenseProduct[]>(`${this.companyApiUrl}/Accounts/${accountId}/LicenseProducts`);
  }

  getUsersPermissions(accountId: string): Observable<AccountPermission[]> {
    return this.http.get<AccountPermission[]>(`${this.summariesApiUrl}/Accounts/${accountId}/UsersPermissions`);
  }

  getConfigurations(accountId: string): Observable<Configurations[]> {
    return this.http.get<Configurations[]>(`${this.projectsApiUrl}/Accounts/${accountId}/Configurations`);
  }

  getAccount(id: string): Observable<Account> {
    return this.http.get<Account>(`${this.apiUrl}/Accounts/${id}`);
  }

  getUserByEmailAsync(email: string): Observable<User> {
    return this.http.get<User>(`${this.summariesApiUrl}/Query/Users/First?email=${email}`);
  }

  insertUserPermission(userPermissionsInputModel: UserPermissionInputModel) {
    let accountId = userPermissionsInputModel.accountId
    let body = JSON.stringify(userPermissionsInputModel)

    return this.http.post(`${this.projectsApiUrl}/Accounts/${accountId}/InsertUserPermission`, body);
  }

  insertConfiguration(userConfigurationUpdateInputModel: configurationInputModel){
    let accountId = userConfigurationUpdateInputModel.accountId
    let systemId = userConfigurationUpdateInputModel.systemId
    let body = JSON.stringify(userConfigurationUpdateInputModel)

    return this.http.post(`${this.projectsApiUrl}/System/${systemId}/Accounts/${accountId}/InsertConfigurations`, body);
  }

  updateUserPermission(userPermissionsUpdateInputModel: UserPermissionInputModel){
    let accountId = userPermissionsUpdateInputModel.accountId
    let body = JSON.stringify(userPermissionsUpdateInputModel)

    return this.http.put(`${this.projectsApiUrl}/Accounts/${accountId}/UpdateUserPermission`, body);
  }

  updateConfiguration(userConfigurationUpdateInputModel: configurationInputModel){
    let accountId = userConfigurationUpdateInputModel.accountId
    let systemId = userConfigurationUpdateInputModel.systemId
    let body = JSON.stringify(userConfigurationUpdateInputModel)

    return this.http.put(`${this.projectsApiUrl}/System/${systemId}/Accounts/${accountId}/Configurations`, body);
  }

  deleteUserPermission(accountId: string, id: string ){
    return this.http.delete(`${this.projectsApiUrl}/Accounts/${accountId}/${id}/DeleteUserPermission`);
  }

  deleteConfiguration(accountId: string, id: string){
    return this.http.delete(`${this.projectsApiUrl}/Accounts/${accountId}/${id}/DeleteConfiguration`);
  }
}